import React from "react";
import { motion } from "framer-motion";

export default function StatCard({
  title,
  value,
  subValue,
  icon: Icon,
  iconColor = "bg-blue-500",
  trend,
  trendUp,
  delay = 0,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay }}
      className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm hover:shadow-md transition-shadow"
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-slate-500">{title}</p>
          <h3 className="text-2xl font-bold text-slate-900 mt-1">{value}</h3>
          {subValue && <p className="text-sm text-slate-400 mt-0.5">{subValue}</p>}
          {trend && (
            <p className={`text-xs mt-2 font-medium ${trendUp ? "text-emerald-600" : "text-red-500"}`}>
              {trendUp ? "↑" : "↓"} {trend}
            </p>
          )}
        </div>
        <div className={`${iconColor} w-11 h-11 rounded-xl flex items-center justify-center shadow-lg`}>
          <Icon className="h-5 w-5 text-white" />
        </div>
      </div>
    </motion.div>
  );
}